import update from 'immutability-helper';
import createReducer from '../../../../../common/utils/createReducer.js';
import { filter } from '../actions/actionTypes.js';

const initialState = {
  config: {},
  applied_filters: {},
  applied_filter_values: {},
  dynamicFilterParams: {},
  dynamicFilterValuesLoading: false,
  filtersLoading: false,
  filtersError: false
};

const reducer = {
  [filter.RESET_FILTERS]: (state, action) => initialState,

  [filter.SET_CONFIG]: (state, action) => {
    const { section, config } = action.payload;
    return update(state, {
      config: {
        [section]: { $set: config }
      }
    });
  },

  [filter.SET_APPLIED_FILTERS]: (state, action) => {
    const { applied_filters } = action.payload;

    const updates = Object.keys(applied_filters).reduce((acc, key) => {
      acc[key] = { $set: applied_filters[key] };
      return acc;
    }, {});

    return update(state, {
      applied_filters: updates
    });
  },

  [filter.SET_APPLIED_FILTER_VALUES]: (state, action) => {
    const { applied_filter_values } = action.payload;

    const updates = Object.keys(applied_filter_values).reduce((acc, key) => {
      acc[key] = { $set: applied_filter_values[key] };
      return acc;
    }, {});

    return update(state, {
      applied_filter_values: updates
    });
  },

  [filter.SET_FILTER_LOADING]: (state, action) => {
    const { loading } = action.payload;

    return update(state, {
      filtersLoading: { $set: loading },
      filtersError: { $set: loading ? false : state.filtersError }
    });
  },

  [filter.SET_FILTER_ERROR]: state => {
    return update(state, {
      filtersError: { $set: true },
      filtersLoading: { $set: false }
    });
  },

  [filter.SET_DYNAMIC_FILTER_PARAMS]: (state, action) => {
    const { keys } = action.payload;
    return update(state, {
      dynamicFilterParams: { $set: keys }
    });
  },

  [filter.SET_DYNAMIC_FILTER_VALUES_LOADING]: (state, action) => {
    const { loading } = action.payload;
    return update(state, {
      dynamicFilterValuesLoading: { $set: loading }
    });
  }
};

export default createReducer(initialState, reducer);
